import { useQuery } from '@tanstack/react-query';
import { getCustomerOnboardingTimeline } from '@api/usageDashboard';
import useUser from '@src/BaseApp/hooks/useUser';
import { ICustomerOnboardingTimeline } from '@src/pages/SelfServeDashboard/typed';
import { isDryRunCustomer } from '@src/pages/SelfServeDashboard/utils';

export const useCustomerOnboardingTimeline = () => {
  const { data: user } = useUser();
  const isDryRun = isDryRunCustomer(user?.customerId);

  return useQuery(
    ['self-serve-customer-onboarding-timeline'],
    async () => {
      const res = await getCustomerOnboardingTimeline();
      return res?.data as ICustomerOnboardingTimeline[];
    },
    {
      enabled: !!user && isDryRun,
    },
  );
};
